import { isAndroid, isIOS, isMacOs, isWindows } from 'react-device-detect';
import { Button, Col, Row, Typography } from 'antd';

import classes from './index.module.less';

const ArticleDownloadBanner = () => {
	const OS = isAndroid
		? 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID'
		: isWindows
		? 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID'
		: isMacOs
		? 'https://apps.apple.com/id/app/hallobumil/id1507726157'
		: isIOS
		? 'https://apps.apple.com/id/app/hallobumil/id1507726157'
		: 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID';
	return (
		<div className={classes.pagehero}>
			<Row>
				<Col md={2} sm={2} xs={1} lg={2} xl={2}></Col>
				<Col md={18} sm={18} xs={22} lg={18} xl={18}>
					<div className={classes.section}>
						<Typography className={classes.title}>
							Baca lewat aplikasi lebih mudah loh, Ma
						</Typography>
						<Typography className={classes.paragraph}>
							Dari artikel kehamilan hingga parenting, semua ada di aplikasi Hallo Bumil. Yuk,
							Download Ma
						</Typography>
					</div>
				</Col>
				<Col md={2} sm={2} xs={1} lg={2} xl={2}></Col>
			</Row>
			<Row>
				<Col md={2} sm={2} xs={1} lg={2} xl={2}></Col>
				<Col md={18} sm={18} xs={22} lg={18} xl={18}>
					<div className={classes.btnFooter}>
						<Button
							className={classes.btn}
							onClick={() => window.open(OS)}
							size="large"
							id="download-sekarang"
						>
							<Typography className={classes.btnText}>Download Sekarang</Typography>
						</Button>
					</div>
				</Col>
				<Col md={2} sm={2} xs={1} lg={2} xl={2}></Col>
			</Row>
		</div>
	);
};

export default ArticleDownloadBanner;
